document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    if (typeof mapContainers !== 'undefined') {
        let markers = [];
        // Declare parser and functions to get SVG strings so they jsou dostupné ve všech scopech.
        const parser = new DOMParser();
        const getSvgDefault = (id) => `<svg class="markerIcon markerIcon--default" data-showroom="${id}" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M35 16.6675C35 28.3342 20 38.3342 20 38.3342C20 38.3342 5 28.3342 5 16.6675C5 12.6892 6.58035 8.87392 9.3934 6.06088C12.2064 3.24783 16.0218 1.66748 20 1.66748C23.9782 1.66748 27.7936 3.24783 30.6066 6.06088C33.4196 8.87392 35 12.6892 35 16.6675Z" fill="#255592" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 21.6675C22.7614 21.6675 25 19.4289 25 16.6675C25 13.9061 22.7614 11.6675 20 11.6675C17.2386 11.6675 15 13.9061 15 16.6675C15 19.4289 17.2386 21.6675 20 21.6675Z" fill="white"/>
        </svg>`;
        const getSvgCurrent = (id) => `<svg class="markerIcon markerIcon--current" data-showroom="${id}" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M20 38.3342L19.584 38.9582C19.8359 39.1261 20.1641 39.1261 20.416 38.9582L20 38.3342ZM20 38.3342C20.416 38.9582 20.4162 38.958 20.4165 38.9579L20.4174 38.9573L20.4201 38.9555L20.4296 38.9491L20.4644 38.9255C20.4816 38.9139 20.5032 38.8991 20.5291 38.8814C20.5488 38.8678 20.5709 38.8526 20.5955 38.8356C20.7092 38.7568 20.8744 38.6408 21.0836 38.4897C21.5022 38.1874 22.0976 37.7441 22.8109 37.1761C24.2365 36.0409 26.1392 34.4027 28.0445 32.3916C31.8243 28.4018 35.75 22.8023 35.75 16.6675C35.75 12.4903 34.0906 8.48425 31.1369 5.53055C28.1832 2.57685 24.1772 0.91748 20 0.91748C15.8228 0.91748 11.8168 2.57685 8.86307 5.53055C5.90937 8.48425 4.25 12.4903 4.25 16.6675C4.25 22.8023 8.1757 28.4018 11.9555 32.3916C13.8608 34.4027 15.7635 36.0409 17.1891 37.1761C17.9024 37.7441 18.4978 38.1874 18.9164 38.4897C19.1256 38.6408 19.2908 38.7568 19.4045 38.8356C19.4614 38.8749 19.5054 38.905 19.5356 38.9255L19.5704 38.9491L19.5799 38.9555L19.5826 38.9573L19.5835 38.9579C19.5838 38.958 19.584 38.9582 20 38.3342Z" fill="#FACC16" stroke="#255592" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 21.6675C22.7614 21.6675 25 19.4289 25 16.6675C25 13.9061 22.7614 11.6675 20 11.6675C17.2386 11.6675 15 13.9061 15 16.6675C15 19.4289 17.2386 21.6675 20 21.6675Z" fill="#255592"/>
        </svg>`;

        async function initMap(mapNode) {
            let position = { lat: 49.743000, lng: 15.339000 };
            const lat = $(mapNode).data('lat');
            const lng = $(mapNode).data('lng');
            if (typeof lat !== 'undefined' && typeof lng !== 'undefined') {
                position = { lat: lat, lng: lng };
            }

            const { Map } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            const showroomMap = new Map(mapNode, {
                zoom: 7,
                center: position,
                mapId: "2e359b26d1e54113",
                disableDefaultUI: true,
            });

            for (let i in showrooms) {
                const showroom = showrooms[i];
                let defaultSvg = getSvgDefault(showroom.id);
                let currentSvg = getSvgCurrent(showroom.id);
                let svgElement = parser.parseFromString(defaultSvg, 'image/svg+xml').documentElement;
                let z = null;

                if (typeof lat === 'undefined' || typeof lng === 'undefined') {
                    if (i == 0) {
                        svgElement = parser.parseFromString(currentSvg, 'image/svg+xml').documentElement;
                        z = 1;
                    }
                } else {
                    if (showroom.lat == lat && showroom.lng == lng) {
                        svgElement = parser.parseFromString(currentSvg, 'image/svg+xml').documentElement;
                        z = 1;
                    }
                }

                const marker = new AdvancedMarkerElement({
                    map: showroomMap,
                    position: {
                        lat: showroom.lat,
                        lng: showroom.lng,
                    },
                    title: showroom.name,
                    content: svgElement,
                    zIndex: z,
                });

                marker.customId = showroom.id;

                marker.addListener("click", () => {
                    // Reset all markers to default
                    markers.forEach(m => {
                        if (m.zIndex === 1) {
                            m.content = parser.parseFromString(getSvgDefault(m.customId), 'image/svg+xml').documentElement;
                            m.zIndex = null;
                        }
                    });

                    // Set current marker to active
                    marker.content = parser.parseFromString(getSvgCurrent(marker.customId), 'image/svg+xml').documentElement;
                    marker.zIndex = 1;

                    // Update showroom preview
                    const showroomId = marker.customId;
                    selectShowroomPreview(showroomId);

                    // Only trigger change if value differs to prevent infinite loop
                    if ($('#showroomId').val() != showroomId) {
                        $('#showroomId').val(showroomId).trigger('change');
                    }
                });

                markers.push(marker);
            }
        }

        var previewsContainer = $('#selected-showroom-previews');
        if (previewsContainer.length) {
            var selectShowroomPreview = function(selectedShowroomId) {
                previewsContainer.children().addClass('d-none');
                $('#selected-showroom-preview-' + selectedShowroomId).removeClass('d-none');
            };

            Livewire.on('showroomChanged', function(selectedShowroomId) {
                // Update preview directly
                selectShowroomPreview(selectedShowroomId);

                // Update marker icons without triggering click events
                markers.forEach(m => {
                    if (m.customId == selectedShowroomId) {
                        m.content = parser.parseFromString(getSvgCurrent(m.customId), 'image/svg+xml').documentElement;
                        m.zIndex = 1;
                    } else {
                        m.content = parser.parseFromString(getSvgDefault(m.customId), 'image/svg+xml').documentElement;
                        m.zIndex = null;
                    }
                });
            });
        }

        // Init map for each container
        Array.from(mapContainers).forEach(mapNode => initMap(mapNode));
    }
});
